import { EWarningMoreInfoType } from '../../../components/AboutHome/components/WarningBanner';

interface IWarningInfoProps {
  isEmergency?: boolean;
  isRenovation?: boolean;
  isCulturalHeritage?: boolean;
}

export function getWarningIfno({ isEmergency, isRenovation, isCulturalHeritage }: IWarningInfoProps) {
  if (isEmergency && isRenovation) {
    return {
      title: 'Дом под снос',
      text: 'Жильцы проголосовали за включение этого дома в программу реновации, жить здесь может быть опасно — дом признан аварийным',
    };
  }

  if (isRenovation) {
    return {
      title: 'Дом под снос',
      text: 'Жильцы проголосовали за включение этого дома в программу реновации',
    };
  }

  if (isEmergency) {
    return {
      title: 'Признан аварийным',
      text: 'Жить здесь может быть опасно',
    };
  }

  if (isCulturalHeritage) {
    return {
      title: 'Есть ограничения по ремонту',
      text: 'Дом — объект культурного наследия',
      moreInfo: {
        title: 'Правила ремонта в объектах культурного наследия',
        type: EWarningMoreInfoType.culturalHeritage,
      },
    };
  }

  return null;
}
